export default __webpack_public_path__ + "e615567912e07c93535d74b4db2c8774.woff";